(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.wasuiGalleryReady === 'true') return;

    var mainImage = gallery.querySelector('.wasui-product-gallery__image');
    var zoomArea = gallery.querySelector('[data-wasui-zoom]');
    var thumbs = gallery.querySelectorAll('[data-wasui-thumb]');

    if (!mainImage || !thumbs.length) return;

    gallery.dataset.wasuiGalleryReady = 'true';

    function setZoomBackground(src) {
      if (!zoomArea) return;
      zoomArea.style.setProperty('--wasui-zoom-image', 'url("' + src + '")');
    }

    setZoomBackground(thumbs[0].dataset.zoomSrc || thumbs[0].dataset.imageSrc || mainImage.currentSrc || mainImage.src);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var imageSrc = thumb.dataset.imageSrc;
        if (!imageSrc) return;

        mainImage.removeAttribute('srcset');
        mainImage.src = imageSrc;
        mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
        setZoomBackground(thumb.dataset.zoomSrc || imageSrc);

        thumbs.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (!zoomArea) return;

    zoomArea.addEventListener('mousemove', function (event) {
      var rect = zoomArea.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      zoomArea.style.setProperty('--wasui-zoom-x', x + '%');
      zoomArea.style.setProperty('--wasui-zoom-y', y + '%');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wasui-product-gallery]').forEach(initGallery);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-wasui-product-gallery]').forEach(initGallery);
  });
})();
